export default "__VITE_ASSET__B2nK_ooB__"